export const CardPendingSVG = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            className="shrink-0"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                transform="matrix(-1 0 0 1 48 0)"
                fill="white"
            />
            <path
                d="M18.018 35.2079H30.495C31.2017 35.2079 31.7747 34.6309 31.7747 33.9191V30.4761C31.7747 30.201 31.6873 29.9331 31.5252 29.7116L27.8349 24.6675C27.512 24.2262 27.5016 23.6276 27.809 23.1752L31.2312 18.1377C31.3768 17.9234 31.4548 17.6697 31.4548 17.4099V13.9422C31.4548 13.2304 30.8818 12.6533 30.1751 12.6533H18.018C17.3112 12.6533 16.7383 13.2304 16.7383 13.9422V17.3851C16.7383 17.6602 16.8257 17.9281 16.9877 18.1496L20.6579 23.1661C20.9905 23.6207 20.9905 24.2405 20.6579 24.6952L16.9877 29.7116C16.8257 29.9331 16.7383 30.201 16.7383 30.4761V33.9191C16.7383 34.6309 17.3112 35.2079 18.018 35.2079Z"
                stroke="#08172B"
                strokeWidth="2.50607"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2188 31.3418H27.2973"
                stroke="#FB5950"
                strokeWidth="2.50607"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="24.2441" cy="24.2441" r="24" fill="white" />
            <path
                d="M33.6608 18.7741L31.89 17.3574V14.6421M38.9733 17.0032C38.9733 20.9153 35.802 24.0866 31.89 24.0866C27.978 24.0866 24.8066 20.9153 24.8066 17.0032C24.8066 13.0912 27.978 9.91992 31.89 9.91992C35.802 9.91992 38.9733 13.0912 38.9733 17.0032Z"
                stroke="#FB5950"
                strokeWidth="2.23295"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6641 19.9375H22.2016"
                stroke="#08172B"
                strokeWidth="2.23295"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.6387 29.3652H19.1266"
                stroke="#08172B"
                strokeWidth="2.23295"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.2383 29.3652H27.2142"
                stroke="#08172B"
                strokeWidth="2.23295"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M36.5436 25.9229V28.9058C36.5436 33.0424 35.4364 34.0795 31.0203 34.0795H17.1873C12.7712 34.0795 11.6641 33.0424 11.6641 28.9058V19.2186C11.6641 15.082 12.7712 14.0449 17.1873 14.0449L21.8295 14.0449"
                stroke="#08172B"
                strokeWidth="2.23295"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
